module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_vm._v("LIST OF SYMBOLS AND SPECIAL CHARACTERS")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("( ) in translations inclose elements not in the original but desirable or necessary for a better understanding in English.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("(?) indicate that the meaning is uncertain.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("[ ] inclose restorations in the text.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/rec1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/rec2.jpg"
    }
  }), _vm._v(" inclose a word, a phrase, or a line which is partially damaged.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v(". . . . (1) in translations indicate that the text is unintelligible to the translator;")]), _vm._v(" "), _c('p', {
    staticClass: "list1i"
  }, [_vm._v("(2) in titles of books indicate omission.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("[. . . .] or "), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/rec1.jpg"
    }
  }), _vm._v(". . . ."), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/rec2.jpg"
    }
  }), _vm._v(" indicate that the text is wholly or partially damaged and therefore unintelligible.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("ˉ")]), _vm._v(" "), _c('i', [_vm._v("or")]), _vm._v(" "), _c('span', {
    staticClass: "sans"
  }, [_vm._v("ˆ")]), _vm._v(" indicates a long vowel.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("˘")]), _vm._v(" indicates a short vowel.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _vm._v(" = "), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/a1.jpg"
    }
  }), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_c('img', {
    staticClass: "sup2",
    attrs: {
      "alt": "image",
      "src": "img/int3.jpg"
    }
  }), _vm._v(" = "), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/a2.jpg"
    }
  }), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_c('i', [_c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int8.jpg"
    }
  })]), _vm._v(" = "), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/a3.jpg"
    }
  }), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_c('i', [_c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int10.jpg"
    }
  })]), _vm._v(" = "), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/a4.jpg"
    }
  }), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_c('i', [_c('span', {
    staticClass: "sans"
  }, [_vm._v("ṡ")])]), _vm._v(" = "), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/a5.jpg"
    }
  }), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_c('i', [_c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int11a.jpg"
    }
  })]), _vm._v(" = "), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/a6.jpg"
    }
  }), _vm._v("."), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('a', {
    attrs: {
      "id": "page_1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f136eac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/9780226112428_09_sym.vue
// module id = 75
// module chunks = 0